export default __webpack_public_path__ + "static/media/agreement-cc48f69dff1cf37440975f49ec7bbc46.png";